module.exports = __webpack_public_path__ + "img/photo-4-1.d808f7f9.jpg";